module.exports = __webpack_public_path__ + "img/ic_reddit.719d408f.svg";